<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal">
    </nav-header>
    <nav-bread ref="child"></nav-bread>
    <div class="container">
      <div class="title_wrap">
        <p class="title_small">上海市临床检验中心</p>
        <p class="title_big">
          关于开展新型冠状病毒（2019-nCoV）
          <br/>
          核酸检测能力申请
        </p>
      </div>
      <div class="content_wrap">
        <div class="introduce_info">
          为配合新型冠状病毒肺炎的防控工作，保证2019-nCoV核酸检测的质量，上海市临床检验中心（CNAS PT0025)、上海市临床检验质量控制中心特别为符合生物安全要求且有资质开展基因扩增检验的实验室免费提供新型冠状病毒（2019-nCoV)核酸检测的能力验证服务。
        </div>
        <div class="introduce_img">
          <img src="../assets/introduce_img.jpg">
        </div>
      </div>
      <div class="title_inline">
        质控计划申请
      </div>
      <div class="step_wrap">
        <ul>
          <li>
            <a class="step_num step_active">1</a>
            <div class="step_title">申请</div>
            <div class="step_info">请有意参加的单位（符合生物安全要求，有资质开展PCR基因扩增检测的实验室），于2020年2月3日-2月10日进行申请</div>
            <div class="step_btn">
              <a @click="toApplyForm">申请表</a>
            </div>
          </li>
          <li>
            <a class="step_num">2</a>
            <div class="step_title">下单</div>
            <div class="step_info">审核通过后会有短信发送至您的手机，你可以点击下方“下单入口”或质控商品专区选购相应的质控品</div>
            <div class="step_btn">
              <a @click="toGoodsList('疫情质控品',10)">下单入口</a>
            </div>
          </li>
          <li>
            <a class="step_num">3</a>
            <div class="step_title">能力验证结果</div>
            <div class="step_info">能力验证结果100%符合为合格，否则为不合格，上海市临床检验中心将对合格单位发放证书</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <nav-footer></nav-footer> -->

  </div>

</template>

<script>
  import axios from 'axios'
  import "./../assets/css/base.css";
  import "@/assets/css/index.css?version=1.0.1";
  import NavHeader from "@/components/Header.vue";
  import NavFooter from "@/components/Footer.vue";
  import NavBread from "@/components/Bread.vue";
  import {getCookie} from "@/util/util.js"
  import 'babel-polyfill'

  export default {
    name: "qualityApply",
    data() {
      return {
        p_showSearch: true,
        p_loginModalFlag: false,
        status: ''
      };
    },
    components: {
      NavHeader,
      NavFooter,
      NavBread
    },
    computed: {
      token() {
        return getCookie("_token")?getCookie("_token"):""
      },
      user() {
        return this.$store.state.user;
      }
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true;
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false;
      },

      toApplyForm () {
        this.$router.push('applyForm')
      },

      toGoodsList(itemName, id) {
        this.$router.push({
          path: "/goodsList",
          query: {
            id: id,
            name: itemName
          }
        })
      },

      getStatus() {
        axios.get("/jys/questionnaire/qualityControlProducts/mobile?mobile=" + this.$store.state.user.mobile).then((res) => {
          if (res.data.code === 0 && res.data.jysQuestionnaire) {
            this.status = res.data.jysQuestionnaire.status
          }
        })
      }
    }
  };
</script>

<style scoped >
  .container {
    width: 75%;
    margin-top: 15px;
    color: #000;
  }
  .title_wrap{
    width: 100%;
    margin: 60px 0;
  }
  .title_big{
    font-size: 16px;
    font-weight: bolder;
    margin: 15px 0;
  }
  .title_inline{
    width: 100%;
    float: left;
    height: 35px;
    line-height: 35px;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 6px solid #00C5B0;
  }
  .content_wrap,
  .step_wrap{
    width: 100%;
    float: left;
  }
  .step_wrap{
    margin: 20px 0 150px 20px;
  }
  .introduce_info{
    width: 70%;
    float: left;
    line-height: 30px;
    text-indent: 28px
  }
  .introduce_img{
    width: 30%;
    float: left;
  }
  .introduce_img img{
    width: 100%;
  }
  .step_wrap li{
    position: relative;
    width: 100%;
    min-height: 200px;
    border-left: 3px solid #d6d6d6;
  }
  .step_wrap li div{
    width: 100%;
    margin-left: 50px;
  }
  .step_num{
    position: absolute;
    top: 0;
    left: -13px;
    color: #000;
    background-color: #d6d6d6;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
  }
  .step_title{
    width: 100%;
    padding-bottom: 15px;
    border-bottom: 1px solid #d6d6d6;
  }
  .step_info{
    padding: 15px 20px;
    color: #8b8b8b;
  }
  .step_btn{
    width: 100%;
    text-align: center;
    padding: 25px 0;
  }
  .step_btn a{
    display: block;
    padding: 8px 0;
    margin: 0 auto;
    width: 200px;
    color: #fff;
    background-color: #00C5B0;
    border-radius: 20px;
  }
  .step_active{
    background-color: #00C5B0;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/QualityApply.vue